module.exports = __webpack_public_path__ + "img/ht.d8e095e0.png";